module.exports = __webpack_public_path__ + "img/draw_bonus1.82359912.png";